import { type FC } from 'react';

import { Button, ButtonProps } from '@/components/shadcn/ui/button';
import { useHeaderWalletDrawerStore } from '@/shared/stores/useHeaderWalletDrawerStore';
import { cn } from '@/utils';

import { useCoinwebWallet } from '../../hooks';

import { ConnectedCoinwebWalletButton } from './components/ConnectedCoinwebWalletButton';

export const ConnectedCoinwebWallet: FC<ButtonProps> = ({ className, children, ...props }) => {
  const { isConnected, connect } = useCoinwebWallet();
  const { toggleDrawer } = useHeaderWalletDrawerStore();

  if (!isConnected) {
    return (
      <Button
        variant="secondary"
        size="sm"
        className={cn('font-cocogoose rounded-xl text-sm font-bold', className)}
        onClick={() => {
          void connect();
        }}
        {...props}
      >
        {children || 'Connect Coinweb Wallet'}
      </Button>
    );
  }

  return (
    <ConnectedCoinwebWalletButton {...props} className={className} onClick={toggleDrawer}>
      {children}
    </ConnectedCoinwebWalletButton>
  );
};
